import React from 'react';
import { Box } from '@mui/material';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import PolicyAcknowledge from './pages/PolicyAcknowledgement/PolicyAcknowledge';

function RootRedirect() {
  const hostname = window.location.hostname;
  const parts = hostname.split('.');
  const first = parts.length > 0 ? parts[0].toLowerCase() : '';
  const location = useLocation();

  if (first === 'training') {
    return <Navigate to={{ pathname: "/whizz-learning/", search: location.search }} replace />;
  } else if (first === 'vendor' || first === 'tprm') {
    return <Navigate to={{ pathname: "/vendor-assessment/", search: location.search }} replace />;
  }
  
  // Default fallback (e.g. 'ack', 'localhost', or no subdomain)
  return <Navigate to={{ pathname: "/policy-acknowledge", search: location.search }} replace />;
}
import WhizzLearningLogin from './pages/TrainingModule/WhizzLearningLogin';
import UserTrainingList from './pages/TrainingModule/UserTrainingList';
import TrainingVideoAssessment from './pages/TrainingModule/TrainingVideoAssessment';
import VendorLogin from './pages/TprmModule/VendorLogin';
import OnboardVendorAssessment from './pages/TprmModule/OnboardVendorAssessment';
import VendorQuestionnairePublic from './pages/TprmModule/VendorQuestionnairePublic';
import VendorReviewPublic from './pages/TprmModule/VendorReviewPublic';
import { GlobalSnackbar } from './ReusableComponents/SnackbarManager';

function App() {
  return (
    <Router>
      <Box className="app-container">
        <GlobalSnackbar />
        <Routes>
          <Route path="/" element={<RootRedirect />} />
          {/* Policy Acknowledge */}
          <Route path="/policy-acknowledge" element={<PolicyAcknowledge />} />

          {/* WhizzLearning — Training Entry Point (isolated from main app) */}
          <Route path="/whizz-learning/" element={<WhizzLearningLogin />} />
          <Route path="/whizz-learning/training-list/" element={<UserTrainingList />} />
          <Route path="/whizz-learning/training-video/:id" element={<TrainingVideoAssessment />} />

          {/* Vendor Assessment — TPRM OTP Portal */}
          <Route path="/vendor-assessment/" element={<VendorLogin />} />
          <Route path="/vendor-assessment/onboard/" element={<OnboardVendorAssessment />} />
          <Route path="/vendor-assessment/assessment/" element={<VendorQuestionnairePublic />} />
          <Route path="/vendor-assessment/review/" element={<VendorReviewPublic />} />
          {/* Legacy route alias for existing emails */}
          <Route path="/vendor-assessment/questionnaire/" element={<OnboardVendorAssessment />} />
        </Routes>
      </Box>
    </Router>
  );
}

export default App;